/**
 * What a file-name rule may contain. The server (FileTypeService.getFileName)
 * replaces every `{path}` in the rule with that value of the document being
 * named, and an unknown path becomes empty. `example` is what the preview on
 * this page shows in its place.
 */
export const FILE_NAME_PLACEHOLDERS = [
  {
    path: "date",
    example: "2026-10-14",
    descriptionKey: "files_types_placeholder_date",
  },
  {
    path: "number",
    example: "0045",
    descriptionKey: "files_types_placeholder_number",
  },
  {
    path: "series.title",
    example: "SUT",
    descriptionKey: "files_types_placeholder_series",
  },
  {
    path: "customer.name",
    example: "Pavyzdys UAB",
    descriptionKey: "files_types_placeholder_customer",
  },
  {
    path: "user.name",
    example: "Jonas Jonaitis",
    descriptionKey: "files_types_placeholder_user",
  },
  {
    path: "company.name",
    example: "Mano įmonė UAB",
    descriptionKey: "files_types_placeholder_company",
  },
  {
    path: "project.name",
    example: "Projektas 1",
    descriptionKey: "files_types_placeholder_project",
  },
  {
    path: "asset.name",
    example: "Kompiuteris",
    descriptionKey: "files_types_placeholder_asset",
  },
  {
    path: "template.name",
    example: "Darbo sutartis",
    descriptionKey: "files_types_placeholder_template",
  },
  {
    path: "fileTypeContext",
    example: "Priedas",
    descriptionKey: "files_types_placeholder_context",
  },
  {
    path: "fuelReport.period",
    example: "2026-09",
    descriptionKey: "files_types_placeholder_fuel_period",
  },
];

/**
 * The file name the rule would give, using the example values above. A
 * placeholder the page has no example for stays as typed: the server may know
 * it, so showing it empty would be a false promise.
 */
export function previewFileName(rule: string): string {
  const preview = rule.replace(/{(.*?)}/g, (written, path) => {
    const placeholder = FILE_NAME_PLACEHOLDERS.find(
      (known) => known.path === path.trim()
    );
    return placeholder ? placeholder.example : written;
  });
  return preview.trim();
}
